const params = new URLSearchParams(window.location.search)

export const platform = params.get('platform') as
  | 'ios'
  | 'googleplay_android'
  | 'china_android'

export const appVersion = params.get('app_version') ?? '0.0.0'

export const language = params.get('language') ?? 'en'

const tsParam = params.get('ts')
const tsNum = tsParam != null ? Number(tsParam) : NaN
// Server "now" (ms) seeded from the `ts` URL param (unix seconds). Fallback
// to `0` signals "not anchored yet" — consumers treat 0 as missing and wait
// for useTimestamp's first /time.js? refetch.
export const seedServerNowMs =
  Number.isFinite(tsNum) && tsNum > 0 ? tsNum * 1000 : 0
